var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4765_891",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4765_891)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5026 11.5026C10.4484 11.5026 9.54601 11.1273 8.79531 10.3766C8.04462 9.62587 7.66927 8.72344 7.66927 7.66927C7.66927 6.6151 8.04462 5.71267 8.79531 4.96198C9.54601 4.21128 10.4484 3.83594 11.5026 3.83594C12.5568 3.83594 13.4592 4.21128 14.2099 4.96198C14.9606 5.71267 15.3359 6.6151 15.3359 7.66927C15.3359 8.72344 14.9606 9.62587 14.2099 10.3766C13.4592 11.1273 12.5568 11.5026 11.5026 11.5026ZM3.83594 19.1693V16.4859C3.83594 15.9429 3.97569 15.4437 4.25521 14.9885C4.53472 14.5333 4.90608 14.1859 5.36927 13.9464C6.35955 13.4512 7.3658 13.0799 8.38802 12.8323C9.41024 12.5847 10.4484 12.4609 11.5026 12.4609C12.5568 12.4609 13.595 12.5847 14.6172 12.8323C15.6394 13.0799 16.6457 13.4512 17.6359 13.9464C18.0991 14.1859 18.4705 14.5333 18.75 14.9885C19.0295 15.4437 19.1693 15.9429 19.1693 16.4859V19.1693H3.83594Z",
    fill: "#695BD6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.ba3cb974b51f7a6b7b492e361e84341a.svg";
export { ForwardRef as ReactComponent };